import { render, staticRenderFns } from "./custom-company-release.vue?vue&type=template&id=84b4e8a2&scoped=true&"
import script from "./custom-company-release.vue?vue&type=script&lang=js&"
export * from "./custom-company-release.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-release.vue?vue&type=style&index=0&id=84b4e8a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b4e8a2",
  null
  
)

export default component.exports